/*
 * @Author: wp
 * @Date: 2023-01-06 15:22:10
 * @Descripttion:
 */
import AccountLayout from '~/components/AccountMain/AccountLayout'
import AccountHome from '~/pages/account/index.vue'
import UserInfo from '~/pages/account/userinfo/index.vue'
import PassManage from '~/pages/account/userinfo/passManage.vue'
import BuyerList from '~/pages/account/buyer-center/buyer-list/index.vue'
import BuyDetails from '~/pages/account/buyer-center/buyer-details/index.vue'
import Collection from '~/pages/account/buyer-center/collection/index.vue'
import MyGoodsList from '~/pages/account/seller-center/seller-list/index.vue'
import SellOrder from '~/pages/account/seller-center/sell-order/index.vue'
import MyGoodsDetails from '~/pages/account/seller-center/seller-details/index.vue'
import OtherGoodsDetails from '~/pages/account/seller-center/seller-other-details/index.vue'
import SellGoodsDetails from '~/pages/account/seller-center/sellGoodsDetails/index.vue'
import BargainMe from '~/pages/account/bargain-center/bargain-me/index.vue'
import BargainMeDetails from '~/pages/account/bargain-center/bargain-me/details.vue'
import BargainSeller from '~/pages/account/bargain-center/bargain-seller/index.vue'
import bargainSellerDetail from '~/pages/account/bargain-center/bargain-seller/details.vue'
import Recovery from '~/pages/account/recovery/index.vue'
import ServeList from '~/pages/account/serveList/index.vue'
import ServeDetails from '~/pages/account/serveList/serveDetails.vue'
import Business from '~/pages/account/recovery/business.vue'
import RecoveryDetail from '~/pages/account/recovery/recoveryDetail.vue'
import AddMoney from '~/pages/account/addMoney/index.vue'
import TiXian from '~/pages/account/tiXian/index.vue'
import TiXianHistory from '~/pages/account/tiXianHistory/index.vue'
import MingXi from '~/pages/account/mingXi/index.vue'
import AddTiXianAccount from '~/pages/account/addTiXianAccount/index.vue'
import TiXianAccount from '~/pages/account/tiXianAccount/index.vue'
import SetPayPassword from '~/pages/account/setPayPassword/index.vue'
import Message from '~/pages/account/message/index.vue'
import MessageDetails from '~/pages/account/messageDetails/index.vue'
import RealName from '~/pages/account/auth-center/realName/index.vue'
import RealPerson from '~/pages/account/auth-center/realPerson/index.vue'
import FaceCode from '~/pages/account/auth-center/realPerson/faceCode.vue'
import RealNameStatus from '~/pages/account/auth-center/realNameStatus/index.vue'
import AuthHome from '~/pages/account/auth-center/authHome/index.vue'
import FaceRecognition from '~/pages/account/auth-center/faceRecognition/index.vue'
import RealNameDetail from '~/pages/account/auth-center/realNameDetail/index.vue'
import ConsultList from '~/pages/account/consultList/index.vue'
import AfterSales from '~/pages/account/afterSale/index.vue'
import Apply from '~/pages/account/afterSale/apply.vue'
import ApplyResult from '~/pages/account/afterSale/result.vue'
import AfterDetail from '~/pages/account/afterSale/detail.vue'
import AfterComment from '~/pages/account/afterSale/comment.vue'
import BatchModify from '~/pages/account/seller-center/batchModify/index.vue'
import Invitee from '~/pages/commissionShare/index.vue'
import Inviter from '~/pages/commissionShare/inviter/index.vue'
import CouponHome from '~/pages/account/coupon/index.vue'
import PromotionRebate from '~/pages/promotionRebate/index.vue'
import PromotionDetail from '~/pages/promotionRebate/promotionDetail.vue'
import EquityExchange from '~/pages/account/equityExchange/index.vue'
import Similar from '~/pages/account/similar/index.vue'
import SelectCoupon from '~/pages/account/seller-center/select-coupon/index.vue'

export default [
	{
		path: '/accountHome',
		component: AccountLayout,
		redirect: '/account',
		meta: { title: '个人中心' },
		children: [
			{
				path: '/account',
				name: 'accountHome',
				component: AccountHome,
				meta: { title: '我的账户' }
			},
			{
				path: '/account/userinfo',
				name: 'userinfo',
				component: UserInfo,
				meta: { title: '个人资料', belongGroupPath: '/account' }
			},
			{
				path: '/account/passManage',
				name: 'passManage',
				component: PassManage,
				meta: { title: '登录密码管理', belongGroupPath: '/account' }
			},
			{
				path: '/account/buyerList',
				name: 'buyerList',
				component: BuyerList,
				meta: {
					title: '我的订单',
					belongGroupPath: '/account',
					keepAlive: true
				}
			},
			{
				path: '/account/buyerDetails',
				name: 'buyerDetails',
				component: BuyDetails,
				meta: { title: '订单详情', belongGroupPath: '/account' }
			},
			{
				path: '/account/collection',
				name: 'collection',
				component: Collection,
				meta: {
					title: '收藏商品',
					belongGroupPath: '/account'
				}
			},
			{
				path: '/account/consultList',
				name: 'consultList',
				component: ConsultList,
				meta: {
					title: '我的咨询',
					belongGroupPath: '/account'
				}
			},
			{
				path: '/account/sellerList',
				name: 'sellerList',
				component: MyGoodsList,
				meta: { title: '我的商品', belongGroupPath: '/account' }
			},
			{
				path: '/account/sellOrder',
				name: 'sellOrder',
				component: SellOrder,
				meta: { title: '出售订单', belongGroupPath: '/account' }
			},
			{
				path: '/account/batchModify',
				name: 'batchModify',
				component: BatchModify,
				meta: { title: '批量改价', belongGroupPath: '/account' }
			},
			{
				path: '/account/sellerDetails',
				name: 'sellerDetails',
				component: MyGoodsDetails,
				meta: { title: '商品详情', belongGroupPath: '/account' }
            },
            {
				path: '/account/sellerOtherDetails',
				name: 'sellerOtherDetails',
				component: OtherGoodsDetails,
				meta: { title: '商品详情', belongGroupPath: '/account' }
            },
			{
				path: '/account/sellGoodsDetails',
				name: 'sellGoodsDetails',
				component: SellGoodsDetails,
				meta: { title: '商品详情', belongGroupPath: '/account' }
            },
            {
                path: '/account/selectCoupon',
                name: 'selectCoupon',
                component: SelectCoupon,
                meta: { title: '曝光券使用', belongGroupPath: '/account' }
            },
			{
				path: '/account/bargainMe',
				name: 'bargainMe',
				component: BargainMe,
				meta: { title: '我是买家', belongGroupPath: '/account' }
			},
			{
				path: '/account/bargainMe/details',
				name: 'bargainMeDetails',
				component: BargainMeDetails,
				meta: { title: '砍价详情', belongGroupPath: '/account' }
			},
			{
				path: '/account/bargainSeller',
				name: 'bargainSeller',
				component: BargainSeller,
				meta: { title: '我是卖家', belongGroupPath: '/account' }
			},
			{
				path: '/account/bargainSeller/detail',
				name: 'bargainSellerDetail',
				component: bargainSellerDetail,
				meta: { title: '我是卖家-报价详情', belongGroupPath: '/account' }
			},
			{
				path: '/account/recovery',
				name: 'recovery',
				component: Recovery,
				meta: { title: '回收中心', belongGroupPath: '/account' }
			},
			{
				path: '/account/serveList',
				name: 'serveList',
				component: ServeList,
				meta: { title: '服务订单', belongGroupPath: '/account' }
			},
			{
				path: '/account/serveDetails',
				name: 'serveDetails',
				component: ServeDetails,
				meta: { title: '订单详情', belongGroupPath: '/account' }
			},
			{
				path: '/account/business',
				name: 'business_center',
				component: Business,
				meta: { title: '商家中心', belongGroupPath: '/account' }
			},
			{
				path: '/account/recoveryDetail',
				name: 'recoveryDetail',
				component: RecoveryDetail,
				meta: { title: '回收详情', belongGroupPath: '/account' }
			},
			{
				path: '/account/addMoney',
				name: 'addMoney',
				component: AddMoney,
				meta: { title: '充值中心', belongGroupPath: '/account' }
			},
			{
				path: '/account/realName',
				name: 'realName',
				component: RealName,
				meta: { title: '实名认证', belongGroupPath: '/account' }
			},
			{
				path: '/account/authHome',
				name: 'authHome',
				component: AuthHome,
				meta: { title: '实人认证', belongGroupPath: '/account' }
			},
			{
				path: '/account/realPerson',
				name: 'realPerson',
				component: RealPerson,
				meta: { title: '实人认证', belongGroupPath: '/realPerson' }
			},
			{
				path: '/account/faceCode',
				name: 'faceCode',
				component: FaceCode,
				meta: { title: '人脸认证', belongGroupPath: '/faceCode' }
			},
			{
				path: '/account/realNameStatus',
				name: 'realNameStatus',
				component: RealNameStatus,
				meta: { title: '实名认证状态', belongGroupPath: '/account' }
			},
			{
				path: '/account/faceRecognition',
				name: 'faceRecognition',
				component: FaceRecognition,
				meta: { title: '人脸认证', belongGroupPath: '/account' }
			},
			{
				path: '/account/realNameDetail',
				name: 'realNameDetail',
				component: RealNameDetail,
				meta: { title: '实名认证', belongGroupPath: '/account' }
			},
			{
				path: '/account/tiXian',
				name: 'tiXian',
				component: TiXian,
				meta: { title: '申请提现', belongGroupPath: '/account' }
			},
			{
				path: '/account/tiXianHistory',
				name: 'tiXianHistory',
				component: TiXianHistory,
				meta: {
					title: '提现记录',
					belongGroupPath: '/account',
					keepAlive: true
				}
			},
			{
				path: '/account/mingXi',
				name: 'mingXi',
				component: MingXi,
				meta: { title: '账单明细', belongGroupPath: '/account' }
			},
			{
				path: '/account/addTiXianAccount',
				name: 'addTiXianAccount',
				component: AddTiXianAccount,
				meta: { title: '添加提现账户', belongGroupPath: '/account' }
			},
			{
				path: '/account/tiXianAccount',
				name: 'tiXianAccount',
				component: TiXianAccount,
				meta: { title: '提现账户', belongGroupPath: '/account' }
			},
			{
				path: '/account/setPayPassword',
				name: 'setPayPassword',
				component: SetPayPassword,
				meta: { title: '设置支付密码', belongGroupPath: '/account' }
			},
			{
				path: '/account/message',
				name: 'message',
				component: Message,
				meta: {
					title: '系统消息',
					belongGroupPath: '/account'
				}
			},
			{
				path: '/account/messageDetails',
				name: 'messageDetails',
				component: MessageDetails,
				meta: { title: '系统消息', belongGroupPath: '/account' }
			},
			{
				path: '/account/afterSales',
				name: 'afterSales',
				component: AfterSales,
				meta: { title: '我的售后', belongGroupPath: '/account' }
			},
			{
				path: '/account/afterSales/apply',
				name: 'apply',
				component: Apply,
				meta: { title: '申请售后', belongGroupPath: '/account' }
			},

			{
				path: '/account/afterSales/result',
				name: 'applyResult',
				component: ApplyResult,
				meta: { title: '申请售后', belongGroupPath: '/account' }
			},

			{
				path: '/account/afterSales/detail',
				name: 'afterDetail',
				component: AfterDetail,
				meta: { title: '售后详情', belongGroupPath: '/account' }
			},

			{
				path: '/account/afterSales/comment',
				name: 'afterComment',
				component: AfterComment,
				meta: { title: '售后评价', belongGroupPath: '/account' }
			},
			{
				path: '/commissionShare',
				name: 'invited',
				component: Invitee,
				meta: { title: '我的邀请', belongGroupPath: '/commissionShare' }
			},
			{
				path: '/commissionShare/inviter',
				name: 'meInvited',
				component: Inviter,
				meta: { title: '邀请中心', belongGroupPath: '/commissionShare' }
			},	
			{
				path: '/account/coupon',
				name: 'couponHome',
				component: CouponHome,
				meta: { title: '我的券包', belongGroupPath: '/account' }
			},
			{
				path: '/promotionRebate',
				name: 'promotionRebate',
				component: PromotionRebate,
				meta: { title: '推广返利', belongGroupPath: '/promotionRebate' }
			},
			{
				path: '/promotionDetail',
				name: 'promotionDetail',
				component: PromotionDetail,
				meta: { title: '我的邀请', belongGroupPath: '/promotionDetail' }
			},
			{
				path: '/account/equityExchange',
				name: 'equityExchange',
				component: EquityExchange,
				meta: { title: '权益兑换', belongGroupPath: '/account' }
			},
			{
				path: '/account/similar',
				name: 'similar',
				component: Similar,
				meta: { title: '找相似', belongGroupPath: '/account' }
			}
		]
	}
]
